import './About.css';

const CAPABILITIES = [
  'Bioequivalence Studies',
  'Regulatory Submissions',
  'Pharmacovigilance',
  'Dossier Preparation (eCTD)',
];

function CheckIcon() {
  return (
    <svg viewBox="0 0 20 20" fill="none" width="16" height="16">
      <path
        d="M4 10.5 8 14l8-9"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function PhoneIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none" width="20" height="20">
      <path
        d="M6.6 10.8c1.3 2.6 3.4 4.7 6 6l2-2c.3-.3.7-.4 1-.2 1.1.4 2.3.6 3.5.6.6 0 1 .4 1 1V20c0 .6-.4 1-1 1C10.6 21 3 13.4 3 4c0-.6.4-1 1-1h3.9c.6 0 1 .4 1 1 0 1.2.2 2.4.6 3.5.1.3 0 .7-.2 1l-2 1.3Z"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function About() {
  return (
    <section className="section" id="about">
      <div className="container about">
        <div className="about__text">
          <span className="eyebrow">About Us</span>
          <h2 className="section-title" style={{ marginBottom: 20 }}>
            Integrated Regulatory &amp; Scientific Solutions
          </h2>
          <p className="about__desc">
            At Shrekruthi Phytoceuticals, we provide integrated pharmaceutical,
            nutraceutical and Ayurvedic development and regulatory solutions
            that help companies accelerate product development while ensuring
            compliance with global regulatory standards. From bioequivalence
            studies to regulatory submissions, our experienced scientific
            professionals deliver reliable, high-quality solutions tailored to
            pharmaceutical, nutraceutical, Ayurvedic, biotechnology and
            healthcare organizations.
          </p>

          <ul className="about__list">
            {CAPABILITIES.map((item) => (
              <li key={item}>
                <span className="about__check">
                  <CheckIcon />
                </span>
                {item}
              </li>
            ))}
          </ul>

          <div className="about__phone">
            <span className="about__phone-icon">
              <PhoneIcon />
            </span>
            <div>
              <span className="about__phone-label">Call to ask any question</span>
              <a href="tel:+919003069189" className="about__phone-number">
                +91 90030 69189
              </a>
            </div>
          </div>
        </div>

        <div className="about__visual" aria-hidden="true">
          <div className="about__panel about__panel--main">
            <svg viewBox="0 0 48 48" fill="none">
              <path
                d="M24 4C14 9 6 20 6 30c0 9.9 8 17 18 17s18-7.1 18-17c0-10-8-21-18-26Z"
                stroke="currentColor"
                strokeWidth="2"
              />
              <path d="M24 8v39" stroke="currentColor" strokeWidth="2" />
            </svg>
            <span>Scientific Rigor</span>
          </div>
          <div className="about__panel about__panel--accent">
            <svg viewBox="0 0 48 48" fill="none">
              <circle cx="24" cy="24" r="18" stroke="currentColor" strokeWidth="2" />
              <path d="M24 12v24M12 24h24" stroke="currentColor" strokeWidth="2" />
            </svg>
            <span>Global Compliance</span>
          </div>
        </div>
      </div>
    </section>
  );
}

export default About;
